import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../services/user.service";


@Component({
  selector: 'app-polizas',
  templateUrl: './polizas.component.html',
  styleUrls: ['./polizas.component.css'],
  providers: [UserService]
})
export class PolizasComponent implements OnInit {

  public codasociado;
  public identity;
  public url;
  public cedulaEncriptada;
  public polizas;
  public token;


  constructor(
    private _userService: UserService,
    private _router: Router,
  ) {
 
  }
  ngOnInit() {
    this.consultarPolizas();
    this.identity =JSON.parse(this._userService.GetsessionStorage('identity'));
    this.token = this._userService.GetsessionStorage('token');
  }
  consultarPolizas(){
    this._userService.getPolizas().subscribe(
        response =>{
          this.polizas = response;
        },
        error =>{
          console.log(<any>error);
        }
    )
  }

  navigate(url,exten){
    window.open(url+this.identity.usuario+exten, "_blank"); 
  }

}
